/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {Modal} from 'react-bootstrap'

import '../../../../../../../../App.css'
import {Template1} from '../Templates/template1'
import {Template2} from '../Templates/template2'
import {Template3} from '../Templates/template3'
import {Template4} from '../Templates/template4'
import {toAbsoluteUrl} from '../../../../../../../../_ePulse/helpers'
import {useMutation} from '@apollo/client'
import {toast} from 'react-toastify'
import {success} from '../../../../../../../../data/Status/success'
import {CHANGE_PRESCRIPTION} from '../../../../../GraphQLQueries/PDFPrescription'
import {useSelector} from 'react-redux'
import useMutationApi from '../../../../../../../../hooks/useMutation'
import {LoadingSpinner} from '../../../../../../../../_ePulse/layout/components/LoadingSpinner'
import {cmToPx} from '../../../../../../../../data/config'

export function ChangeTemplate(props: any) {
  const dataUser: any = useSelector((state) => {
    return state
  })
  const [selectedTemplate, setSelectedTemplate] = useState<any>('template_1')
  const [selectedTemplatename, setSelectedTemplatename] = useState<any>('template_1')
  const [isloading, setLoading] = useState(false)
  const {
    name,
    qualification,
    address,
    email,
    phoneNo,
    businessNo,
    hospitalName,
    website,
    doctorImage,
    logoImage,
    signature,
    headerImage,
    headerHeight,
    footerHeight,
  } = props

  const {createData, loading, error, data} = useMutationApi(CHANGE_PRESCRIPTION)

  const templates = [
    {id: 'template_1', img: '/media/ePulse/template1.png', width: '200px', height: '200px'},
    {id: 'template_2', img: '/media/ePulse/template2.png', width: '200px', height: '200px'},
    {id: 'template_3', img: '/media/ePulse/template3.png', width: '200px', height: '200px'},
    {id: 'template_4', img: '/media/ePulse/template4.png', width: '150px', height: '200px'},
  ]

  const setPrescriptionCallAPI = async () => {
    try {
      // await setPrescription({
      //   variables: {
      //     doctorId: dataUser?.auth?.userId,
      //     templateName: selectedTemplatename,
      //   },
      // })

      const res = await createData({
        doctorId: dataUser?.auth?.userId,
        templateName: selectedTemplatename,
      })
      toast.success(success.PRESCRIPTION_UPDATED)
      props.selectedTemplate(selectedTemplate)
      props.setModalState(false)
      setLoading(false)
    } catch (error: any) {
      setLoading(false)
    }
  }

  return (
    <>
      <div>
        <Modal
          show={props.modalState}
          //   aria-labelledby='contained-modal-title-vcenter'
          size='xl'
          //   aria-labelledby='example-custom-modal-styling-title'
          dialogClassName='ePulse-modal-90w'
          onHide={() => props.setModalState(false)}
        >
          <Modal.Header closeButton className='fw-bold fs-4'>
            Change Template
          </Modal.Header>
          <Modal.Body className='px-4 d-flex flex-row'>
            <div className='col-8 m-1'>
              <LoadingSpinner isLoading={loading} />
              {selectedTemplate === 'template_1' && (
                <Template1
                  name={name}
                  qualification={qualification}
                  address={address}
                  email={email}
                  phoneNo={phoneNo}
                  businessNo={businessNo}
                  hospitalName={hospitalName}
                  website={website}
                  doctorImage={doctorImage}
                  signature={signature}
                  logoImage={logoImage}
                />
              )}
              {selectedTemplate === 'template_2' && (
                <Template2
                  name={name}
                  qualification={qualification}
                  address={address}
                  email={email}
                  phoneNo={phoneNo}
                  businessNo={businessNo}
                  hospitalName={hospitalName}
                  website={website}
                  doctorImage={doctorImage}
                  signature={signature}
                  logoImage={logoImage}
                />
              )}
              {selectedTemplate === 'template_3' && (
                <Template3
                  name={name}
                  qualification={qualification}
                  address={address}
                  email={email}
                  phoneNo={phoneNo}
                  businessNo={businessNo}
                  hospitalName={hospitalName}
                  website={website}
                  doctorImage={doctorImage}
                  signature={signature}
                  logoImage={logoImage}
                  headerImage={headerImage}
                />
              )}
              {selectedTemplate === 'template_4' && (
                <Template4
                  name={name}
                  qualification={qualification}
                  address={address}
                  email={email}
                  phoneNo={phoneNo}
                  businessNo={businessNo}
                  hospitalName={hospitalName}
                  website={website}
                  doctorImage={doctorImage}
                  signature={signature}
                  logoImage={logoImage}
                  headerHeight={cmToPx(headerHeight || 0)}
                  footerHeight={cmToPx(footerHeight || 0)}
                />
              )}
            </div>
            <div className='col-4 d-flex flex-column m-1'>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gridGap: '1px',
                  height: '420px',
                  overflowY: 'scroll',
                }}
              >
                {templates.map(({id, img, width, height}) => (
                  <div
                    key={id}
                    className={`p-1  ${selectedTemplate === id ? 'selected-template' : ''}`}
                  >
                    <img
                      src={toAbsoluteUrl(img)}
                      width={width}
                      height={height}
                      alt=''
                      className='me-3'
                      onClick={() => {
                        setSelectedTemplate(id)
                        setSelectedTemplatename(id)
                      }}
                      style={{cursor: 'pointer'}}
                    />
                  </div>
                ))}
              </div>

              <div className='d-flex flex-row justify-content-end mt-6 '>
                <button
                  className='border border-dark col py-2 fs-5 rounded-pill  me-5'
                  onClick={() => props.setModalState(false)}
                >
                  <span className='fw-semibold'>Cancel</span>
                </button>
                <button
                  className='border-0 ePulse-appColor-primary col py-2 fs-5 rounded-pill text-white '
                  onClick={() => {
                    setPrescriptionCallAPI()
                  }}
                >
                  <span className='fw-semibold'>Select Template</span>
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}
